export const AUTH_URL = process.env.NEXT_PUBLIC_AUTH_URL;
export const FNO_AUTH_URL = process.env.NEXT_PUBLIC_FNO_AUTH_URL
export const AUTH_URL_CUSTOMER_SUBSCRIPTION_KEY = process.env.NEXT_PUBLIC_AUTH_URL_CUSTOMER_SUBSCRIPTION_KEY
export const FNO_AUTH_URL_FNOAPIM_SUBSCRIPTION_KEY = process.env.NEXT_PUBLIC_AUTH_URL_FNOAPIM_SUBSCRIPTION_KEY
export const CONTACT_AUTH_URL=process.env.NEXT_PUBLIC_CONTACT_AUTH_URL
export const OCP_APIM_SUBSCRIPTION_KEY =process.env.NEXT_PUBLIC_OCP_APIM_SUBSCRIPTION_KEY
export const AZURE_URL=process.env.NEXT_PUBLIC_AZURE_URL
export const FEEDBACK_URL=process.env.NEXT_PUBLIC_FEEDBACK_URL
export const NORMAL_FEEDBACK_URL=process.env.NEXT_PUBLIC_NORMAL_FEEDBACK_URL